import { Component, HostBinding, Input } from '@angular/core';
import { DbsSize } from './dbs-spinner.size';

@Component({
  selector: 'dbs-spinner',
  templateUrl: './dbs-spinner.component.html',
  styleUrls: ['./dbs-spinner.component.scss'],
})

export class DbsSpinnerComponent {

  @Input() inside: boolean;

  @Input() size: DbsSize = 'medium';

  isFirstTime: boolean = false;

  @HostBinding('class.size-tiny')
  get tiny() {
    return this.size === 'tiny';
  }

  @HostBinding('class.size-giant')
  get giant() {
    return this.size === 'giant';
  }
}
